/*
 * @Author: Hallie Liu 
 * @Date: 2019-04-07 20:12:04 
 * @Last Modified by:   Hallie Liu 
 * @Last Modified time: 2019-04-07 20:12:04 
 */
'use strict'

import { NICHEFRAGRANCE } from "../constants/ActionTypes"

const initState = {
    // CAROUSEL_ORDER: 1,
    // CURRENT_SCENE: 0,
    // ENTRANCPRELOADED: false,
    // CURRENTBRANDPRELOADED: false,
    MORE_PRODUCTS: false,
    MYSOURCEDATA: {},
    DRAWER: false,
    MYVIDEO: '',
    PAGINATION: null,
    SCENESTATUS:{
        CAROUSEL_ORDER: 1,
        CURRENT_SCENE: 0
    },
    PRELOADSTATUS:{
        ENTRANCPRELOADED: false,
        CURRENTBRANDPRELOADED: false
    }
}

export default function ( state = initState, action = {} ){
    switch( action.type ){
        case NICHEFRAGRANCE.SCENESTATUS :
            return Object.assign({},state,{
                SCENESTATUS:action.SCENESTATUS
            });
        break;
        case NICHEFRAGRANCE.PRELOADSTATUS :
            return Object.assign({},state,{
                PRELOADSTATUS:action.PRELOADSTATUS
            });
        break;
        // case NICHEFRAGRANCE.CAROUSEL_ORDER :
        //     return Object.assign({},state,{
        //         CAROUSEL_ORDER:action.CAROUSEL_ORDER
        //     });
        // break;
        // case NICHEFRAGRANCE.CURRENT_SCENE :
        //     return Object.assign({},state,{
        //         CURRENT_SCENE:action.CURRENT_SCENE
        //     });
        // break;
        // case NICHEFRAGRANCE.ENTRANCPRELOADED :
        // return Object.assign({},state,{
        //     ENTRANCPRELOADED:action.ENTRANCPRELOADED
        // });
        // break;
        // case NICHEFRAGRANCE.CURRENTBRANDPRELOADED :
        // return Object.assign({},state,{
        //     CURRENTBRANDPRELOADED:action.CURRENTBRANDPRELOADED
        // });
        // break;
        case NICHEFRAGRANCE.MORE_PRODUCTS :
            return Object.assign({},state,{
                MORE_PRODUCTS:action.MORE_PRODUCTS
            });
        break;
        case NICHEFRAGRANCE.MYVIDEO :
            return Object.assign({},state,{
                MYVIDEO:action.MYVIDEO
            });
        break;
        case NICHEFRAGRANCE.DRAWER :
            return Object.assign({},state,{
                DRAWER:action.DRAWER
            });
        break;
        case NICHEFRAGRANCE.MYSOURCEDATA :
        return Object.assign({},state,{
            MYSOURCEDATA:action.MYSOURCEDATA
        });
        break;
        case NICHEFRAGRANCE.PAGINATION :
        return Object.assign({},state,{
            PAGINATION:action.PAGINATION
        });
        break;
        
        default:
            return state;break;
    }
}









// WEBPACK FOOTER //
// ./common/reducers/nicheFragrance.js